exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-60878550]{min-height:200px}.detail-container .section-title[data-v-60878550]{font-size:16px;font-weight:bold;color:#303133;margin-bottom:15px;padding-bottom:10px;border-bottom:2px solid #409eff}.detail-container .section-title[data-v-60878550]:not(:first-child){margin-top:30px}.detail-container .detail-table[data-v-60878550]{margin-bottom:15px}.detail-container .detail-pagination[data-v-60878550]{text-align:right;margin-top:15px}", ""]);

// exports
